import './GiftCardPage.style';

import { PureComponent } from 'react';

import Form from 'Component/Form';
import Field from 'Component/Field';
import TextPlaceholder from 'Component/TextPlaceholder';
import { formatCurrency, roundPrice } from 'Util/Price';

export class GiftCardPage extends PureComponent {
    renderImage() {
        const { image, loading } = this.props;

        if (!image && !loading) {
            return null;
        }

        return (
            <div block="GiftCard" elem="Image" mods={{ Loading: loading }}>
                { image && <img src={ image } /> }
            </div>
        )
    }

    renderTitle() {
        const { title, loading } = this.props;

        if (!title && !loading) {
            return null;
        }

        return (
            <h1 block="GiftCard" elem="Title"><TextPlaceholder content={ title } length="short" /></h1>
        )
    }

    renderShortDescription() {
        const { short_description, loading } = this.props;

        if (loading) {
            return (
                <div block="GiftCard" elem="ShortDescription"><TextPlaceholder length="paragraph" /></div>
            )
        }

        if (!short_description) {
            return null;
        }
        return (
            <div block="GiftCard" elem="ShortDescription" dangerouslySetInnerHTML={{ __html: short_description }} />
        )
    }

    renderDescription() {
        const { description, loading } = this.props;

        if (loading) {
            return (
                <div block="GiftCard" elem="Description"><TextPlaceholder length="paragraph" /></div>
            )
        }

        if (!description) {
            return null;
        }

        return (
            <div block="GiftCard" elem="Description" dangerouslySetInnerHTML={{ __html: description }} />
        )
    }

    renderStep() {
        const {
            card_step,
            card_value,
            card_input,
            quote_currency_code,
            onStepClick,
            onCustomStepChange,
            onCustomStepKeyPress
        } = this.props;

        if (!card_step) {
            return null;
        }

        return (
            <div block="GiftCard" elem="Steps">
                <strong>{__('Choose the value of the card')}</strong>
                <span>{ `${card_value} ${formatCurrency(quote_currency_code)}` }</span>
                <ul>
                    { card_step.map((step, index) => (
                        <li key={ index }>
                            <span
                                block="GiftCard"
                                elem="Step"
                                mods={{ isSelected: ( card_value == step && !card_input ) }}
                                onClick={ () => onStepClick(step) }
                            >
                                { `${step} ${formatCurrency(quote_currency_code)}` }
                            </span>
                        </li>
                    )) }
                    <li>
                        <input
                            block="GiftCard"
                            elem="Input"
                            mods={{ isSelected: card_input.length > 0 }}
                            type="text"
                            placeholder={ __("another value (50-999 €)") }
                            value={ card_input }
                            onKeyPress={ onCustomStepKeyPress }
                            onChange={ onCustomStepChange }
                        />
                    </li>
                </ul>
            </div>
        )
    }

    renderFormWrapper() {
        const { onFormSubmitSuccess } = this.props;

        return (
            <div block="GiftCard" elem="FormWrapper">
                <Form
                    onSubmitSuccess={ onFormSubmitSuccess }
                >
                    { this.renderFields() }
                    { this.renderPrice() }
                    { this.renderAddToCart() }
                </Form>
            </div>
        )
    }

    renderFields() {
        const { card_terms, onTermsClick } = this.props;

        return (
            <div block="GiftCard" elem="Form">
                <legend><strong>{__("Recipient")}</strong> ({__("the details of the person to whom you are giving the gift")})</legend>
                <Field
                    type="text"
                    name="recipient_name"
                    id="recipient_name"
                    label={__("Name")}
                    value=""
                    validation={ ['notEmpty'] }
                />
                <Field
                    type="text"
                    name="recipient_email"
                    id="recipient_email"
                    label={__("Email")}
                    value=""
                    validation={ ['notEmpty', 'email'] }
                />
                <legend><strong>{__("From")}</strong> ({__("your personal data")})</legend>
                <Field
                    type="text"
                    name="sender_name"
                    id="sender_name"
                    label={__("Name")}
                    value=""
                    validation={ ['notEmpty'] }
                />
                <Field
                    type="textarea"
                    name="message"
                    id="message"
                    value=""
                    placeholder={__("Message")}
                    validation={ ['notEmpty', 'lengthMax250'] }
                />
                <Field
                    type="checkbox"
                    name="terms_and_conditions"
                    id="terms_and_conditions"
                    validation={ ['notEmpty'] }
                    value={ card_terms }
                    onClick={ onTermsClick }
                    label={ __("I agree to <a href='/page/terms-and-conditions' target='_blank'>terms and conditions</a>") }
                />
            </div>
        )
    }

    renderPrice() {
        const { card_value, quote_currency_code } = this.props;

        if (!card_value) {
            return null;
        }

        return (
            <div block="GiftCard" elem="Price">
                { `${card_value} ${formatCurrency(quote_currency_code)}` }
            </div>
        )
    }

    renderAddToCart() {
        const { isLoading } = this.props;

        return (
            <div block="GiftCard" elem="AddToCart">
                <button
                    block="Button"
                    mods={ { isLoading } }
                    disabled={ isLoading }
                >
                    <span>{ __('Add to cart') }</span>
                    <span>{ __('Adding...') }</span>
                </button>
            </div>
        )
    }

    render() {
        return (
            <div block="GiftCard">
                <div block="GiftCard" elem="Container">
                    { this.renderImage() }
                    <div block="GiftCard" elem="Main">
                        { this.renderTitle() }
                        { this.renderShortDescription() }
                        { this.renderStep() }
                        { this.renderFormWrapper() }
                    </div>
                    { this.renderDescription() }
                </div>
            </div>
        );
    }
}

export default GiftCardPage;
